export default "__VITE_ASSET__BnhbSJ0U__"